export function Auth() {

    const auth = document.querySelector('.js-auth');

    if (!auth) return;

    const authAgreement = auth.querySelector('.js-auth-agreement');
    const authAgreementGroup = auth.querySelector('.js-auth-agreement-group');
    const authAgreementEntry = auth.querySelector('.js-auth-agreement-entry');
    const authSms = auth.querySelector('.js-auth-sms');
    const authSmsGroup = auth.querySelector('.js-auth-sms-group');
    const authSmsEntry = auth.querySelector('.js-auth-sms-entry');
    const authSmsResend = auth.querySelector('.js-auth-sms-resend');
    const authSmsTimer = auth.querySelector('.js-auth-sms-timer');
    const authSmsTimerValue = auth.querySelector('.js-auth-sms-timer-value');
    const resendSmsTime = 30;
    let smsResendInterval;

    authAgreement.addEventListener('submit', (event) => {
        event.preventDefault();

        if (!isAgreementValid()) {
            authAgreementEntry.classList.add('_error');
            triggerFocus(authAgreementEntry);
        }
    });

    authAgreementEntry.addEventListener('input', () => {
        if (authAgreementEntry.classList.contains('_error') || authAgreementGroup.classList.contains('_error')) {
            authAgreementEntry.classList.remove('_error');
            authAgreementGroup.classList.remove('_error');
        }
    });

    authSms.addEventListener('submit', (event) => {
        if (authSmsEntry.value == '') {
            event.preventDefault();
            authSmsEntry.classList.add('_error');
            triggerFocus(authSmsEntry);
        }
    });

    authSmsEntry.addEventListener('input', () => {
        if (authSmsEntry.classList.contains('_error') || authSmsGroup.classList.contains('_error')) {
            authSmsEntry.classList.remove('_error');
            authSmsGroup.classList.remove('_error');
        }
    });



    function isAgreementValid() {
        if (authAgreementEntry.value == '') {
            return false;
        } else {
            return true;
        }
    }

    function loadAgreement() {
        authAgreement.classList.add('_loading');
        authAgreementEntry.disabled = true;
    }

    function showAgreementError() {
        authAgreementEntry.disabled = false;
        authAgreement.classList.remove('_loading');
        authAgreementEntry.classList.add('_error');
        authAgreementGroup.classList.add('_error');
        triggerFocus(authAgreementEntry);
    }

    function showAgreementSuccess() {
        authAgreement.classList.remove('_loading');
        authAgreement.classList.add('_success');
        triggerFocus(authSmsEntry);
        startSmsTimer();
    }

    function loadSms() {
        authSms.classList.add('_loading');
        authSmsEntry.disabled = true;
        authSmsResend.classList.add('_hidden');
        stopSmsTimer();
    }

    function showSmsError() {
        authSms.classList.remove('_loading');
        authSmsGroup.classList.add('_error');
        authSmsEntry.classList.add('_error');
        authSmsEntry.disabled = false;
        triggerFocus(authSmsEntry);
        authSmsResend.classList.remove('_hidden');
    }

    function resendSms() {
        authSms.classList.remove('_loading');
        authSmsEntry.value = '';
        authSmsEntry.disabled = false;
        triggerFocus(authSmsEntry);
        startSmsTimer();
    }

    function startSmsTimer() {
        let time = resendSmsTime;

        authSmsTimerValue.innerHTML = time;
        authSmsResend.classList.add('_hidden');
        authSmsTimer.classList.remove('_hidden');

        smsResendInterval = setInterval(() => {
            if (time == 0) {
                authSmsResend.classList.remove('_hidden');
                stopSmsTimer();
            } else {
                authSmsTimerValue.innerHTML = time - 1;
                time--;
            }
        }, 1000);
    }

    function stopSmsTimer() {
        authSmsTimer.classList.add('_hidden');
        clearInterval(smsResendInterval);
    }

    function triggerFocus(element) {
        let focusEvent;

        if (typeof(Event) === 'function') {
            focusEvent = new Event('focus');
        } else {
            focusEvent = document.createEvent('Event');
            focusEvent.initEvent('focus', true, true);
        }

        element.focus();
        element.dispatchEvent(focusEvent);
    }

    this.isAgreementValid = isAgreementValid;
    this.loadAgreement = loadAgreement;
    this.showAgreementError = showAgreementError;
    this.showAgreementSuccess = showAgreementSuccess;
    this.loadSms = loadSms;
    this.showSmsError = showSmsError;
    this.resendSms = resendSms;
}